import { ExternalLink } from "./index";
import XeroLogo from "img/Xero";
import React from "react";
import { useXeroDeepLink, XeroDeepLinkOptions } from "hooks";

export const XeroDeepLink = (props: XeroDeepLinkOptions) => {
  const link = useXeroDeepLink(props);

  if (!link) {
    return null;
  }

  return (
    <ExternalLink href={link} target="_blank" rel="noopener noreferrer">
      <XeroLogo width="32px" />
    </ExternalLink>
  );
};
